<template>
  <div>
    <div class="section-header">
      <h1>Courses</h1>
    </div>
    <div class='row flex-wrap'>
      <course-card 
        v-for="(course, i) in courses"
        :course="course"
        :key="course.id"
        :img="backgroundImg(course, i)"
        @click="$router.push({name: 'courseDetail', params: {id: course.id}})" />
    </div>
  </div>
</template>

<script>
import dataStore from "@/services/api/store";
import courseCard from "@/components/courses/courseCard";

export default {
  data() {
    return {
      courses: []
    };
  },
  components: { courseCard },
  created() {
    dataStore.find("ClientCourses").then(result => {
      this.courses = result;
    });
  },
  methods: {
    backgroundImg(course, i) {
      let images = ['mountains.jpeg', 'butterflys.jpeg', 'fall.jpeg', 'flowers.jpeg', 'thunder.jpeg', 'trees.jpg'];
      let image = "";
      if (!course.background_image) {
        image = "/img/" + images[i % images.length];
      } else {
        image = course.background_image;
      }
      return image;
    }
  }
}
</script>


